import { NetworkConfiguration } from "../../network/networkConfriguation";
import { callAPI } from "../../network/networkConnection";

const connectWithShopify = (payload) => {
  return new Promise((resolve, reject) => {
    callAPI(
      process.env.REACT_APP_APIUrl + NetworkConfiguration.CONNECT_TO_SHOPIFY,
      "POST",
      {
        "Content-Type": "application/json",
      },
      payload
    )
      .then((res) => {
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

const getStoresList = () => {
  return new Promise((resolve, reject) => {
    callAPI(
      process.env.REACT_APP_APIUrl + NetworkConfiguration.SHOPIFY_STORE_LIST,
      "GET",
      {
        "Content-Type": "application/json",
      }
    )
      .then((res) => {
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};
const connectAmazon = () => {
  return new Promise((resolve, reject) => {
    callAPI(
      process.env.REACT_APP_APIUrl + NetworkConfiguration.AMAZON_CONNECT,
      "GET",
      {
        "Content-Type": "application/json",
      }
    )
      .then((res) => {
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

const disconnectShopify = (payload) => {
  return new Promise((resolve, reject) => {
    callAPI(
      process.env.REACT_APP_APIUrl + NetworkConfiguration.DISCONNECT_SHOPIFY,
      "DELETE",
      {
        "Content-Type": "application/json",
      },
      payload
    )
      .then((res) => {
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

const getShopifyOAuthUrl = (shop, apiKey, apiSecret) => {
  return new Promise((resolve, reject) => {
    // Send API Key and Secret in request body via POST
    callAPI(
      process.env.REACT_APP_APIUrl + `user/shopify/connect?shop=${encodeURIComponent(shop)}`,
      "POST",
      {
        "Content-Type": "application/json",
        "Accept": "application/json",
      },
      JSON.stringify({
        shopifyApiKey: apiKey,
        shopifyApiSecret: apiSecret,
      })
    )
      .then((res) => {
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

export const marketPlaceApiService = {
  connectWithShopify,
  getStoresList,
  connectAmazon,
  disconnectShopify,
  getShopifyOAuthUrl,
};
